import { mapActions, mapGetters } from 'vuex'
import useAuthStore from '@/stores/authStore'

// ADA-4410: all token writes converge on the Pinia authStore (single source of
// truth). The methods below are the only places legacy code mutated tokens;
// they now delegate to authStore actions. `user_tokens` is exposed as a
// computed bridge in the legacy shape ({ token_list, selected_token }) for
// remaining readers (navigation/Token.vue). set_user_tokens was removed with
// its only caller, the legacy Authenticate view (ADA-4497).
export const user_mixin = {
    computed: {
        user_tokens() {
            const authStore = useAuthStore()
            if (authStore.tokensList.length === 0) {
                return null
            }
            return {
                token_list: authStore.tokensList.map(({ token }) => ({ token })),
                selected_token: String(authStore.tokensList.findIndex((t) => t.selected)),
            }
        },
        ...mapGetters(['selected_token']),
    },
    methods: {
        async select_token(new_selected_token) {
            const authStore = useAuthStore()
            const entry = authStore.tokensList[Number(new_selected_token)]
            if (entry == null) {
                return
            }
            authStore.selectToken(entry.token)
        },
        async update_token(token_data) {
            useAuthStore().updateCurrentToken(token_data)
        },
        async logout_user(reason) {
            useAuthStore().clearAllTokens()

            const base_data = {
                pre_login_user_tokens: null,
                public_token: null,
                user: {},
                payment: {},
                media: {},
                profile_dialog: {},
                message_dialog: {},
                unread_tickets: 0,
                unhandled_overpayments: 0,
                dont_show_profile_dialog: false,
                direct_debit_payments: {},
            }

            const promises = []
            for (const [k, v] of Object.entries(base_data)) {
                promises.push(
                    this.set_state_property({
                        property: k,
                        data: v,
                    })
                )
            }
            await Promise.all(promises)
            sessionStorage.removeItem('dont_show_profile_dialog')
            const target = reason
                ? { path: '/authenticate', query: { reason } }
                : '/authenticate'
            this.$router.replace(target)
        },
        ...mapActions(['set_state_property', 'update_key_in_state_property']),
    },
}
